import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { userAuthenticated } from '@capital-access/common/actions';
import { forkJoin, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { UserRepository } from '../user.repository';
import { loadUserProfileFail, loadUserProfileSuccess } from './user.actions';

@Injectable()
export class CommonUserEffects {
  loadUserProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userAuthenticated),
      filter(({ isInitializingImpersonation }) => !isInitializingImpersonation),
      switchMap(() => {
        const userRequest = this.repository.getUserProfile();
        const accountRequest = this.repository.getUserAccount();
        return forkJoin([userRequest, accountRequest]).pipe(
          map(([userProfile, account]) => {
            if (account?.engageEmail) {
              userProfile.account.engageEmail = account.engageEmail;
            }
            if (account?.accountSubType) {
              userProfile.account.accountSubType = account.accountSubType;
            }
            return loadUserProfileSuccess({ userProfile });
          }),
          catchError(error => of(loadUserProfileFail({ error })))
        );
      })
    )
  );

  constructor(private actions$: Actions, private repository: UserRepository) {}
}
